/* ==========================================================================
   HUMO BARRILES · MUNDO INTERACTIVO (ruta + ventas por estado)
   assets/humo-mundo.js

   Motor propio en canvas 2D, sin librerías. Reglas de rendimiento:
   1. No arranca hasta que la sección está cerca de la pantalla.
   2. El archivo geográfico se pide en ese momento, no al cargar la página.
   3. Solo dibuja mientras la sección está a la vista.
   4. El mapa de estados se dibuja una vez en memoria y solo se repinta
      el estado que el cursor toca.
   5. En celular baja la resolución y el ritmo de cuadros.
   ========================================================================== */
(function (W) {
  'use strict';

  var RAD = Math.PI / 180;
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function lerp(a, b, t) { return a + (b - a) * t; }

  var ABBR = {
    'Alabama':'AL','Alaska':'AK','Arizona':'AZ','Arkansas':'AR','California':'CA','Colorado':'CO',
    'Connecticut':'CT','Delaware':'DE','Florida':'FL','Georgia':'GA','Hawaii':'HI','Idaho':'ID',
    'Illinois':'IL','Indiana':'IN','Iowa':'IA','Kansas':'KS','Kentucky':'KY','Louisiana':'LA',
    'Maine':'ME','Maryland':'MD','Massachusetts':'MA','Michigan':'MI','Minnesota':'MN',
    'Mississippi':'MS','Missouri':'MO','Montana':'MT','Nebraska':'NE','Nevada':'NV',
    'New Hampshire':'NH','New Jersey':'NJ','New Mexico':'NM','New York':'NY','North Carolina':'NC',
    'North Dakota':'ND','Ohio':'OH','Oklahoma':'OK','Oregon':'OR','Pennsylvania':'PA',
    'Rhode Island':'RI','South Carolina':'SC','South Dakota':'SD','Tennessee':'TN','Texas':'TX',
    'Utah':'UT','Vermont':'VT','Virginia':'VA','Washington':'WA','West Virginia':'WV',
    'Wisconsin':'WI','Wyoming':'WY','Puerto Rico':'PR','District of Columbia':'DC'
  };
  /* estados chicos del noreste: su etiqueta sale a un costado con una línea */
  var CHICOS = { VT: 1, NH: 1, MA: 1, RI: 1, CT: 1, NJ: 1, DE: 1, MD: 1 };
  /* dónde poner la etiqueta cuando el centro geométrico queda mal */
  var ANCLA = {
    FL: [-81.6, 28.2], LA: [-92.4, 31.0], MI: [-84.7, 43.3], KY: [-85.3, 37.5],
    VA: [-78.6, 37.6], WV: [-80.6, 38.7], ID: [-114.6, 44.0], CA: [-119.6, 37.2],
    NY: [-75.6, 42.9], TN: [-86.3, 35.8], OK: [-97.3, 35.5], TX: [-99.0, 31.3],
    MN: [-94.4, 46.3], NC: [-79.3, 35.6], MS: [-89.7, 32.7], AL: [-86.8, 32.8]
  };
  var FUERA = { AK: 1, HI: 1, PR: 1 };

  /* ======================================================================
     MOTOR DE DIBUJO
     ====================================================================== */
  function Motor(cv, geo) {
    var ctx = cv.getContext('2d');
    var Wd = 0, Hd = 0, DPR = 1;

    var MUNDO = geo.world || geo.mundo || [];
    var AMER = geo.americas || geo.america || [];
    var ESTADOS = (geo.states || geo.estados || []).map(function (f) {
      return { n: f.n, s: ABBR[f.n] || '', p: f.p };
    }).filter(function (e) { return e.s; });
    /* países donde está Humo: se buscan por nombre en todas las capas del
       archivo geográfico, con o sin tilde, para no depender de su estructura */
    function limpio(t) { return String(t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
    var BUSCADOS = ['colombia', 'venezuela', 'mexico', 'united states of america', 'united states',
                    'estados unidos', 'canada'];
    var NUESTROS = [], vistos = {};
    Object.keys(geo).forEach(function (k) {
      if (!Array.isArray(geo[k])) return;
      geo[k].forEach(function (f) {
        var n = limpio(f && f.n);
        if (n && BUSCADOS.indexOf(n) !== -1 && !vistos[n === 'united states' || n === 'estados unidos' ? 'united states of america' : n]) {
          vistos[n === 'united states' || n === 'estados unidos' ? 'united states of america' : n] = 1;
          NUESTROS.push(f);
        }
      });
    });

    var cam = { lon: -80, lat: 16, z: 1, cx: 0, cy: 0, R: 1 };
    var P = [0, 0, 0];

    function medir(w, h, dpr) {
      Wd = w; Hd = h; DPR = dpr;
      cv.width = Math.max(1, Math.round(w * dpr));
      cv.height = Math.max(1, Math.round(h * dpr));
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      tab.listo = false;
    }

    /* ---------- globo ortográfico ---------- */
    function proy(lon, lat, out) {
      var l = (lon - cam.lon) * RAD, f = lat * RAD, f0 = cam.lat * RAD;
      var cf = Math.cos(f), sf = Math.sin(f), cf0 = Math.cos(f0), sf0 = Math.sin(f0);
      var cl = Math.cos(l);
      out[0] = cam.cx + cam.R * cf * Math.sin(l);
      out[1] = cam.cy - cam.R * (cf0 * sf - sf0 * cf * cl);
      out[2] = sf0 * sf + cf0 * cf * cl;
      return out;
    }

    function anillo(pts, paso) {
      var abierto = false, p;
      for (var k = 0; k < pts.length; k += paso) {
        p = proy(pts[k][0], pts[k][1], P);
        if (p[2] > 0) {
          if (abierto) ctx.lineTo(p[0], p[1]); else { ctx.moveTo(p[0], p[1]); abierto = true; }
        } else abierto = false;
      }
    }
    function capa(datos, paso) {
      for (var a = 0; a < datos.length; a++) {
        var anillos = datos[a].p;
        for (var b = 0; b < anillos.length; b++) anillo(anillos[b], paso);
      }
    }
    function graticula() {
      ctx.beginPath();
      var lon, lat, a, primero;
      for (lon = -180; lon < 180; lon += 20) {
        primero = true;
        for (lat = -80; lat <= 80; lat += 5) {
          a = proy(lon, lat, P);
          if (a[2] > 0) { if (primero) ctx.moveTo(a[0], a[1]); else ctx.lineTo(a[0], a[1]); primero = false; }
          else primero = true;
        }
      }
      for (lat = -60; lat <= 60; lat += 20) {
        primero = true;
        for (lon = -180; lon <= 180; lon += 5) {
          a = proy(lon, lat, P);
          if (a[2] > 0) { if (primero) ctx.moveTo(a[0], a[1]); else ctx.lineTo(a[0], a[1]); primero = false; }
          else primero = true;
        }
      }
      ctx.strokeStyle = 'rgba(160,190,210,.07)';
      ctx.lineWidth = 1;
      ctx.stroke();
    }

    /* ruta con interpolación esférica */
    function vec(lon, lat) { var f = lat * RAD, l = lon * RAD; return [Math.cos(f) * Math.cos(l), Math.cos(f) * Math.sin(l), Math.sin(f)]; }
    function geoDe(v) { return [Math.atan2(v[1], v[0]) / RAD, Math.asin(clamp(v[2], -1, 1)) / RAD]; }
    function slerp(a, b, t) {
      var d = clamp(a[0] * b[0] + a[1] * b[1] + a[2] * b[2], -1, 1), o = Math.acos(d);
      if (o < 1e-6) return a;
      var s = Math.sin(o), k1 = Math.sin((1 - t) * o) / s, k2 = Math.sin(t * o) / s;
      return [a[0] * k1 + b[0] * k2, a[1] * k1 + b[1] * k2, a[2] * k1 + b[2] * k2];
    }
    var RUTA = [];
    function fijarRuta(puntos) {
      RUTA = [];
      for (var r = 0; r < puntos.length - 1; r++) {
        var a = vec(puntos[r][0], puntos[r][1]), b = vec(puntos[r + 1][0], puntos[r + 1][1]);
        for (var t = 0; t < 24; t++) RUTA.push(geoDe(slerp(a, b, t / 24)));
      }
      RUTA.push(puntos[puntos.length - 1]);
    }
    function puntoRuta(p) {
      var k = clamp(p, 0, 1) * (RUTA.length - 1);
      var a = RUTA[Math.floor(k)], b = RUTA[Math.min(Math.ceil(k), RUTA.length - 1)], t = k - Math.floor(k);
      return [lerp(a[0], b[0], t), lerp(a[1], b[1], t)];
    }
    function trazoRuta(hasta) {
      var abierto = false, p;
      ctx.beginPath();
      for (var k = 0; k <= hasta; k++) {
        p = proy(RUTA[k][0], RUTA[k][1], P);
        if (p[2] > 0) { if (abierto) ctx.lineTo(p[0], p[1]); else { ctx.moveTo(p[0], p[1]); abierto = true; } }
        else abierto = false;
      }
    }

    /* datos: { lon, lat, z, cx, cy, R, prog, q:{TX:3}, umbral, movil } */
    function globo(d) {
      cam.lon = d.lon; cam.lat = d.lat; cam.z = d.z;
      cam.cx = d.cx; cam.cy = d.cy; cam.R = d.R * d.z;
      var R = cam.R, cx = cam.cx, cy = cam.cy;
      ctx.clearRect(0, 0, Wd, Hd);

      /* halo dorado del borde, detrás del planeta */
      var halo = ctx.createRadialGradient(cx, cy, R * 0.92, cx, cy, R * 1.22);
      halo.addColorStop(0, 'rgba(255,214,0,.30)');
      halo.addColorStop(0.35, 'rgba(255,214,0,.10)');
      halo.addColorStop(1, 'rgba(255,214,0,0)');
      ctx.fillStyle = halo;
      ctx.beginPath(); ctx.arc(cx, cy, R * 1.22, 0, 6.2832); ctx.fill();

      ctx.save();
      var mar = ctx.createRadialGradient(cx - R * .3, cy - R * .35, R * .05, cx, cy, R);
      mar.addColorStop(0, '#15273A'); mar.addColorStop(.6, '#0B1724'); mar.addColorStop(1, '#050A12');
      ctx.beginPath(); ctx.arc(cx, cy, R, 0, 6.2832); ctx.closePath();
      ctx.fillStyle = mar; ctx.fill(); ctx.clip();

      graticula();

      /* con poco zoom se salta puntos: misma silueta, menos trabajo */
      var paso = d.z < 1.15 ? (d.movil ? 3 : 2) : 1;

      ctx.beginPath(); capa(MUNDO, paso);
      ctx.strokeStyle = 'rgba(232,236,240,.30)'; ctx.lineWidth = .8; ctx.stroke();

      ctx.beginPath(); capa(AMER, paso);
      ctx.strokeStyle = 'rgba(240,242,245,.55)'; ctx.lineWidth = 1; ctx.stroke();

      /* estados: se ven al acercar; los que ya tienen ventas brillan */
      var aEst = clamp((d.z - 1.25) / .6, 0, 1);
      if (aEst > 0) {
        ctx.globalAlpha = aEst;
        ctx.beginPath(); capa(ESTADOS, 1);
        ctx.strokeStyle = 'rgba(240,242,245,.38)'; ctx.lineWidth = .7; ctx.stroke();
        ctx.globalAlpha = 1;
      }
      /* brillo dorado barato: un trazo ancho translúcido y uno fino encima,
         sin shadowBlur, que es lo que más cuesta en cada cuadro */
      function dorado(fino) {
        ctx.lineJoin = 'round';
        ctx.strokeStyle = 'rgba(255,214,0,.16)'; ctx.lineWidth = fino * 4.2; ctx.stroke();
        ctx.strokeStyle = 'rgba(255,214,0,.32)'; ctx.lineWidth = fino * 2.2; ctx.stroke();
        ctx.strokeStyle = '#FFE24A'; ctx.lineWidth = fino; ctx.stroke();
      }

      /* países donde está Humo: Colombia, Venezuela, México, EE. UU. y Canadá */
      if (NUESTROS.length) {
        ctx.beginPath(); capa(NUESTROS, paso === 3 ? 2 : 1);
        dorado(1.6);
      }

      /* estados desbloqueados */
      var q = d.q || {}, U = d.umbral || 10, hay = false;
      ctx.beginPath();
      for (var e = 0; e < ESTADOS.length; e++) if ((q[ESTADOS[e].s] || 0) >= U) { capa([ESTADOS[e]], 1); hay = true; }
      if (hay) dorado(1.6);

      /* ruta: completa punteada y recorrido dorado */
      if (RUTA.length) {
        var hasta = Math.floor(clamp(d.prog, 0, 1) * (RUTA.length - 1));
        trazoRuta(RUTA.length - 1);
        ctx.setLineDash([4, 7]); ctx.strokeStyle = 'rgba(240,242,245,.65)'; ctx.lineWidth = 1.6; ctx.stroke();
        ctx.setLineDash([]);
        trazoRuta(hasta);
        dorado(2.4);
      }

      /* luz y sombra del planeta */
      var sh = ctx.createRadialGradient(cx - R * .45, cy - R * .5, R * .1, cx, cy, R * 1.15);
      sh.addColorStop(0, 'rgba(255,236,200,.07)');
      sh.addColorStop(.5, 'rgba(0,0,0,0)');
      sh.addColorStop(1, 'rgba(0,0,0,.72)');
      ctx.fillStyle = sh; ctx.fillRect(cx - R, cy - R, R * 2, R * 2);
      ctx.restore();

      /* borde encendido */
      ctx.save();
      ctx.beginPath(); ctx.arc(cx, cy, R, 0, 6.2832);
      ctx.strokeStyle = 'rgba(255,226,74,.85)'; ctx.lineWidth = 2;
      ctx.shadowColor = 'rgba(255,214,0,.8)'; ctx.shadowBlur = 18; ctx.stroke();
      ctx.restore();
    }

    /* ======================================================================
       TABLERO: Estados Unidos plano (Albers)
       ====================================================================== */
    var tab = { listo: false, capa: null, est: [], callouts: [], caja: null };

    function albers(lon, lat, out) {
      var f1 = 29.5 * RAD, f2 = 45.5 * RAD, f0 = 37.5 * RAD, l0 = -96 * RAD;
      var n = (Math.sin(f1) + Math.sin(f2)) / 2;
      var C = Math.cos(f1) * Math.cos(f1) + 2 * n * Math.sin(f1);
      var r0 = Math.sqrt(C - 2 * n * Math.sin(f0)) / n;
      var r = Math.sqrt(C - 2 * n * Math.sin(lat * RAD)) / n;
      var th = n * (lon * RAD - l0);
      out[0] = r * Math.sin(th);
      out[1] = -(r0 - r * Math.cos(th));
      return out;
    }

    function centroide(ring) {
      var A = 0, x = 0, y = 0;
      for (var k = 0, j = ring.length - 1; k < ring.length; j = k++) {
        var c = ring[j][0] * ring[k][1] - ring[k][0] * ring[j][1];
        A += c; x += (ring[j][0] + ring[k][0]) * c; y += (ring[j][1] + ring[k][1]) * c;
      }
      if (!A) return [ring[0][0], ring[0][1], 0];
      return [x / (3 * A), y / (3 * A), Math.abs(A / 2)];
    }

    /* opciones: { q, umbral, margen:{arr,aba,izq,der}, txt:{faltan:fn}, fuente } */
    function construir(o) {
      var mg = o.margen, q = o.q || {}, U = o.umbral || 10;
      var crudo = [], minx = 1e9, maxx = -1e9, miny = 1e9, maxy = -1e9, pt = [0, 0];
      ESTADOS.forEach(function (e) {
        if (FUERA[e.s]) return;
        var anillos = [], mayor = null, area = 0;
        e.p.forEach(function (ring) {
          var pr = ring.map(function (c) { albers(c[0], c[1], pt); return [pt[0], pt[1]]; });
          pr.forEach(function (c) {
            if (c[0] < minx) minx = c[0]; if (c[0] > maxx) maxx = c[0];
            if (c[1] < miny) miny = c[1]; if (c[1] > maxy) maxy = c[1];
          });
          anillos.push(pr);
          var ce = centroide(pr); if (!mayor || ce[2] > area) { area = ce[2]; mayor = ce; }
        });
        var ancla = ANCLA[e.s] ? albers(ANCLA[e.s][0], ANCLA[e.s][1], [0, 0]) : mayor;
        crudo.push({ n: e.n, s: e.s, anillos: anillos, c: [ancla[0], ancla[1]] });
      });

      var aw = Wd - mg.izq - mg.der, ah = Hd - mg.arr - mg.aba;
      var esc = Math.min(aw / (maxx - minx), ah / (maxy - miny));
      var ox = mg.izq + (aw - (maxx - minx) * esc) / 2 - minx * esc;
      var oy = mg.arr + (ah - (maxy - miny) * esc) / 2 - miny * esc;
      tab.caja = { x0: minx * esc + ox, x1: maxx * esc + ox, y0: miny * esc + oy, y1: maxy * esc + oy };

      tab.est = crudo.map(function (e) {
        var path = new (W.Path2D)();
        e.anillos.forEach(function (r) {
          for (var k = 0; k < r.length; k++) {
            var x = r[k][0] * esc + ox, y = r[k][1] * esc + oy;
            if (k) path.lineTo(x, y); else path.moveTo(x, y);
          }
          path.closePath();
        });
        var qq = q[e.s] || 0;
        return { n: e.n, s: e.s, path: path, x: e.c[0] * esc + ox, y: e.c[1] * esc + oy,
                 q: qq, nivel: qq >= U ? 2 : (qq > 0 ? 1 : 0) };
      });

      /* el estado más cerca de desbloquear */
      var cerca = null;
      tab.est.forEach(function (e) { if (e.nivel === 1 && (!cerca || e.q > cerca.q)) cerca = e; });
      tab.cerca = cerca;

      /* etiquetas al costado para los chicos del noreste */
      var chicos = tab.est.filter(function (e) { return CHICOS[e.s]; }).sort(function (a, b) { return a.y - b.y; });
      var xc = Math.min(Wd - 46, tab.caja.x1 + Math.max(26, (Wd - tab.caja.x1) * .18));
      var yUlt = -1e9;
      tab.callouts = chicos.map(function (e) {
        var y = Math.max(e.y, yUlt + 19);
        yUlt = y;
        return { e: e, x: xc, y: y };
      });

      pintarBase(o);
      tab.listo = true;
    }

    function pintarBase(o) {
      var fuente = o.fuente || 'Anton, Impact, sans-serif';
      var texto = o.texto || 'Archivo, system-ui, sans-serif';
      var c = tab.capa;
      if (!c) { c = tab.capa = (W.document ? W.document.createElement('canvas') : o.crearCanvas(1, 1)); }
      c.width = cv.width; c.height = cv.height;
      var g = c.getContext('2d');
      g.setTransform(DPR, 0, 0, DPR, 0, 0);
      g.clearRect(0, 0, Wd, Hd);
      g.lineJoin = 'round';

      /* 1. todos los estados, apagados */
      tab.est.forEach(function (e) {
        g.fillStyle = 'rgba(255,255,255,.018)';
        g.fill(e.path);
        g.strokeStyle = 'rgba(244,236,225,.22)'; g.lineWidth = 1;
        g.stroke(e.path);
      });
      /* 2. arrancados: borde crema con brillo */
      g.save();
      g.shadowColor = 'rgba(255,246,200,.55)'; g.shadowBlur = 6;
      tab.est.forEach(function (e) {
        if (e.nivel !== 1) return;
        g.strokeStyle = 'rgba(255,246,206,.9)'; g.lineWidth = 1.4; g.stroke(e.path);
      });
      g.restore();
      /* 3. desbloqueados: relleno dorado y borde encendido */
      g.save();
      tab.est.forEach(function (e) {
        if (e.nivel !== 2) return;
        g.fillStyle = 'rgba(255,214,0,.16)'; g.fill(e.path);
        g.shadowColor = 'rgba(255,214,0,.95)'; g.shadowBlur = 16;
        g.strokeStyle = '#FFE24A'; g.lineWidth = 2.4; g.stroke(e.path);
        g.shadowBlur = 0;
      });
      g.restore();

      /* 4. etiquetas */
      var base = Math.max(10, Math.min(14, Wd / 95));
      g.textAlign = 'center'; g.textBaseline = 'middle';
      tab.est.forEach(function (e) {
        if (!e.q || CHICOS[e.s]) return;
        etiqueta(g, e, e.x, e.y, base, fuente, texto, o);
      });
      /* 5. chicos del noreste, con su línea */
      g.textAlign = 'left';
      tab.callouts.forEach(function (k) {
        var e = k.e;
        g.strokeStyle = e.q ? 'rgba(244,236,225,.45)' : 'rgba(244,236,225,.18)';
        g.lineWidth = 1;
        g.beginPath(); g.moveTo(e.x, e.y); g.lineTo(k.x - 6, k.y); g.stroke();
        g.fillStyle = e.q ? 'rgba(244,236,225,.9)' : 'rgba(244,236,225,.35)';
        g.beginPath(); g.arc(e.x, e.y, 1.8, 0, 6.2832); g.fill();
        g.font = '700 ' + (base - 1) + 'px ' + texto;
        g.fillStyle = e.nivel === 2 ? '#FFE24A' : (e.q ? '#F4ECE1' : 'rgba(244,236,225,.4)');
        g.fillText(e.s, k.x, k.y);
        if (e.q) {
          g.fillStyle = e.nivel === 2 ? '#FFE24A' : 'rgba(244,236,225,.7)';
          g.font = '400 ' + (base - 1) + 'px ' + texto;
          g.fillText(String(e.q), k.x + base * 2.2, k.y);
        }
      });
    }

    function etiqueta(g, e, x, y, base, fuente, texto, o) {
      if (e.nivel === 2) {
        g.font = (base + 1) + 'px ' + fuente;
        var w = g.measureText(e.s).width + 14, h = base + 9;
        g.fillStyle = '#FFE24A';
        g.beginPath();
        if (g.roundRect) g.roundRect(x - w / 2, y - h / 2 - 7, w, h, h / 2); else g.rect(x - w / 2, y - h / 2 - 7, w, h);
        g.fill();
        g.fillStyle = '#0B0C10'; g.fillText(e.s, x, y - 6);
        g.font = (base + 3) + 'px ' + fuente;
        g.fillStyle = '#FFE24A'; g.fillText(String(e.q), x, y + base + 2);
      } else {
        g.font = '700 ' + base + 'px ' + texto;
        g.fillStyle = 'rgba(244,236,225,.92)'; g.fillText(e.s, x, y - 6);
        g.font = (base + 2) + 'px ' + fuente;
        g.fillStyle = '#E9D98C'; g.fillText(String(e.q), x, y + base * .9);
      }
      if (tab.cerca === e && o.txt && o.txt.faltan) {
        g.font = '700 ' + (base - 2) + 'px ' + texto;
        g.fillStyle = '#FF4B3E';
        g.fillText(o.txt.faltan((o.umbral || 10) - e.q), x, y + base * 2.2);
      }
    }

    function pintarTablero(sel) {
      ctx.clearRect(0, 0, Wd, Hd);
      if (!tab.listo) return;
      ctx.save();
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.drawImage(tab.capa, 0, 0);
      ctx.restore();
      if (sel) {
        ctx.save();
        ctx.fillStyle = 'rgba(255,255,255,.13)'; ctx.fill(sel.path);
        ctx.shadowColor = 'rgba(255,255,255,.8)'; ctx.shadowBlur = 12;
        ctx.strokeStyle = '#FFFFFF'; ctx.lineWidth = 2.2; ctx.stroke(sel.path);
        ctx.restore();
      }
    }

    function estadoEn(x, y) {
      if (!tab.listo) return null;
      for (var k = 0; k < tab.est.length; k++) {
        if (ctx.isPointInPath(tab.est[k].path, x * DPR, y * DPR)) return tab.est[k];
      }
      /* los chicos también se eligen tocando su etiqueta */
      for (var c = 0; c < tab.callouts.length; c++) {
        var co = tab.callouts[c];
        if (Math.abs(y - co.y) < 10 && x > co.x - 8 && x < co.x + 60) return co.e;
      }
      return null;
    }

    return {
      medir: medir, proy: proy, globo: globo, fijarRuta: fijarRuta, puntoRuta: puntoRuta,
      construir: construir, pintarTablero: pintarTablero, estadoEn: estadoEn,
      estados: function () { return tab.est; },
      nombres: ESTADOS
    };
  }

  W.HumoMundoMotor = Motor;
  W.HUMO_ABBR = ABBR;

  if (typeof document === 'undefined') return;

  /* ======================================================================
     INTERFAZ
     ====================================================================== */
  var raiz = document.querySelector('[data-mundo]');
  if (!raiz) return;

  var CFG = {};
  try { CFG = JSON.parse(raiz.querySelector('[data-mundo-cfg]').textContent) || {}; } catch (e) {}

  var TX = {
    es: {
      dias: 'días', horas: 'horas', min: 'min', seg: 'seg',
      zarpa: 'Zarpe estimado desde Cartagena', llega: 'Llegada estimada a Miami', llego: 'El contenedor ya llegó a Miami',
      nota: function (s, l) { return 'Salida tentativa ' + s + ' · llegada tentativa ' + l + '. La posición se estima por fecha, no es rastreo satelital del buque.'; },
      meta: 'Preórdenes confirmadas',
      metaNota: 'El primer contenedor trae 184 barriles. Cada preorden aparta uno.',
      pre: 'preórdenes', pre1: 'preorden',
      faltan: function (n) { return 'faltan ' + n; },
      fichaNada: 'Nadie ha preordenado aquí todavía. El primero lo enciende.',
      fichaFalta: function (n, t) { return 'Faltan ' + n + ' ' + (n === 1 ? 'preorden' : 'preórdenes') + ' para desbloquear' + (t === 'c' ? 'la.' : 'lo.'); },
      fichaOk: function (t) { return (t === 'c' ? 'Ciudad desbloqueada' : (t === 'p' ? 'País desbloqueado' : 'Estado desbloqueado')) + ': aquí ya hay comunidad Humo.'; },
      canada: 'Canadá', fichaPais: 'Todas las preórdenes de Canadá suman aquí.',
      resumen: function (a, t, c) { return a + ' de ' + t + ' estados desbloqueados.' + (c ? ' A ' + c.n + ' le ' + (c.f === 1 ? 'falta 1.' : 'faltan ' + c.f + '.') : ''); },
      vacioEst: 'Todavía no hay preórdenes. El mapa se enciende con la primera.',
      vacioCiu: 'Todavía no hay ciudades. La primera preorden la pone en el mapa.',
      explorar: 'Explorar', volver: 'Volver',
      paradas: [
        ['Cartagena', 'El buque zarpa por el Caribe, pasa entre Cuba y Yucatán y entra a Florida por el estrecho.'],
        ['Canal de Yucatán', 'Cruza entre Cuba y México en mar abierto.'],
        ['Miami', 'Pasa aduana en Florida y sale el primer despacho.']
      ]
    },
    en: {
      dias: 'days', horas: 'hours', min: 'min', seg: 'sec',
      zarpa: 'Estimated departure from Cartagena', llega: 'Estimated arrival in Miami', llego: 'The container has arrived in Miami',
      nota: function (s, l) { return 'Tentative departure ' + s + ' · tentative arrival ' + l + '. Position is estimated by date, not satellite tracking.'; },
      meta: 'Confirmed pre-orders',
      metaNota: 'The first container holds 184 barrels. Every pre-order takes one.',
      pre: 'pre-orders', pre1: 'pre-order',
      faltan: function (n) { return n + ' to go'; },
      fichaNada: 'Nobody has pre-ordered here yet. The first one lights it up.',
      fichaFalta: function (n) { return n + ' more ' + (n === 1 ? 'pre-order' : 'pre-orders') + ' to unlock it.'; },
      fichaOk: function (t) { return (t === 'c' ? 'City' : (t === 'p' ? 'Country' : 'State')) + ' unlocked: the Humo community is already here.'; },
      canada: 'Canada', fichaPais: 'Every pre-order from Canada adds up here.',
      resumen: function (a, t, c) { return a + ' of ' + t + ' states unlocked.' + (c ? ' ' + c.n + ' needs ' + c.f + ' more.' : ''); },
      vacioEst: 'No pre-orders yet. The map lights up with the first one.',
      vacioCiu: 'No cities yet. The first pre-order puts one on the map.',
      explorar: 'Explore', volver: 'Back',
      paradas: [
        ['Cartagena', 'The ship sails across the Caribbean, between Cuba and Yucatán, into Florida.'],
        ['Yucatán Channel', 'It crosses between Cuba and Mexico on open water.'],
        ['Miami', 'It clears customs in Florida and the first shipment goes out.']
      ]
    }
  };
  function idioma() { return (W.HUMO_IDIOMA && W.HUMO_IDIOMA.get()) || 'es'; }
  function T(k) { return TX[idioma()][k]; }

  var $ = function (s) { return raiz.querySelector(s); };
  var movil = function () { return W.innerWidth <= 767; };
  var reducido = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- datos ---------- */
  var U_EST = Number(CFG.umbralEstado) || 10;
  var U_CIU = Number(CFG.umbralCiudad) || 5;
  var Q = CFG.estados || {};
  var CIUDADES = (CFG.ciudades || []).filter(function (c) { return c && isFinite(c.lon) && isFinite(c.lat); });
  if (CFG.demo) {
    Q = { TX: 34, FL: 28, CA: 24, NY: 21, GA: 15, NJ: 13, IL: 11, NC: 10, PA: 9, MA: 8, VA: 7, MD: 6,
          CT: 5, WA: 5, OH: 4, MI: 4, CO: 3, AZ: 3, NV: 2, MN: 2, TN: 2, UT: 1, OR: 1, WI: 1, MO: 1, IN: 1, LA: 1, SC: 1 };
    CIUDADES = [
      { n: 'Miami', lon: -80.19, lat: 25.77, q: 10 }, { n: 'Houston', lon: -95.37, lat: 29.76, q: 6 },
      { n: 'Orlando', lon: -81.38, lat: 28.54, q: 4 }, { n: 'Atlanta', lon: -84.39, lat: 33.75, q: 3 },
      { n: 'New York', lon: -74.01, lat: 40.71, q: 3 }, { n: 'Los Angeles', lon: -118.24, lat: 34.05, q: 3 },
      { n: 'Chicago', lon: -87.63, lat: 41.88, q: 2 }, { n: 'Dallas', lon: -96.8, lat: 32.78, q: 2 },
      { n: 'Washington D.C.', lon: -77.04, lat: 38.91, q: 1 }
    ];
  }
  CIUDADES.sort(function (a, b) { return (b.q || 0) - (a.q || 0); });

  /* Canadá: un solo contador para todo el país. Llega dentro de estados
     con la clave CAN (California ya usa CA). */
  var CANADA = Number(Q.CAN) || 0;
  if (Q.CAN !== undefined) { Q = JSON.parse(JSON.stringify(Q)); delete Q.CAN; }

  /* sedes Humo: marcadores fijos con el logo */
  var SEDES = [
    { n: 'Humo Colombia', lon: -74.3, lat: 4.6, casa: true },
    { n: 'Humo Venezuela', lon: -66.6, lat: 7.6 },
    { n: 'Humo México', lon: -102.0, lat: 23.8 },
    { n: 'Humo Europa', lon: 10.0, lat: 50.0 }
  ];
  var LOGO = '<svg viewBox="0 0 32 44" aria-hidden="true"><path d="M20.4 1.2c1.9 5.4 1.2 9.1-1.6 13.1-2 2.9-2.7 5.1-1.9 7.4.5 1.4 1.6 2.6 2.4 3.2-.2-2.4.6-4.4 2.3-6.3 2.6 4.3 3.3 8 2 11.5-1.6 4.3-5.6 7.4-10.3 7.9C8.3 38.6 3.9 35.2 2.6 30.3 1.3 25.6 3 21.5 7.6 17.2 12.8 12.3 15.3 7.2 14.6 1c2.3.6 4.3 1.5 5.8 3.1z" fill="currentColor"/></svg>';

  var RUTA = [[-75.51, 10.39], [-77.6, 12.6], [-80.4, 15.4], [-83.2, 18.6], [-85.0, 21.2],
              [-84.6, 23.1], [-82.0, 24.1], [-80.13, 25.77]];

  /* ---------- reloj por fechas reales ---------- */
  var SALIDA = Date.parse(CFG.salida || '') || 0;
  var LLEGADA = Date.parse(CFG.llegada || '') || 0;
  function progFecha() {
    if (!SALIDA || !LLEGADA || LLEGADA <= SALIDA) return 0;
    return clamp((Date.now() - SALIDA) / (LLEGADA - SALIDA), 0, 1);
  }
  function fechaCorta(ms) {
    var d = new Date(ms);
    var mes = idioma() === 'es'
      ? ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']
      : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return idioma() === 'es' ? d.getDate() + ' ' + mes[d.getMonth()] + ' ' + d.getFullYear()
                             : mes[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
  }
  var rel = {
    rot: $('[data-m-reloj-rot]'), d: $('[data-m-d]'), h: $('[data-m-h]'), m: $('[data-m-m]'), s: $('[data-m-s]'),
    barra: $('[data-m-barra]'), nota: $('[data-m-nota]')
  };
  function dos(n) { return n < 10 ? '0' + n : '' + n; }
  function tic() {
    var ahora = Date.now(), fin = ahora < SALIDA ? SALIDA : LLEGADA;
    if (rel.rot) rel.rot.textContent = ahora < SALIDA ? T('zarpa') : (ahora >= LLEGADA ? T('llego') : T('llega'));
    var r = Math.max(0, fin - ahora), t = Math.floor(r / 1000);
    if (rel.d) rel.d.textContent = dos(Math.floor(t / 86400));
    if (rel.h) rel.h.textContent = dos(Math.floor(t % 86400 / 3600));
    if (rel.m) rel.m.textContent = dos(Math.floor(t % 3600 / 60));
    if (rel.s) rel.s.textContent = dos(t % 60);
    if (rel.barra) rel.barra.style.width = (progFecha() * 100).toFixed(1) + '%';
  }
  function textosFijos() {
    var es = idioma() === 'es';
    [['[data-m-lab-d]', 'dias'], ['[data-m-lab-h]', 'horas'], ['[data-m-lab-m]', 'min'], ['[data-m-lab-s]', 'seg']]
      .forEach(function (p) { var el = $(p[0]); if (el) el.textContent = T(p[1]); });
    if (rel.nota && SALIDA && LLEGADA) rel.nota.textContent = TX[es ? 'es' : 'en'].nota(fechaCorta(SALIDA), fechaCorta(LLEGADA));
    var bx = $('[data-m-explorar]'); if (bx) bx.textContent = explorando ? T('volver') : T('explorar');
    tic();
  }
  if (SALIDA && LLEGADA) { tic(); setInterval(tic, 1000); }

  /* ---------- rankings ---------- */
  function ranking(lista, el, vacio, total) {
    if (!el) return;
    var top = lista.filter(function (x) { return x.q > 0; }).slice(0, total);
    if (!top.length) { el.innerHTML = '<p class="hb-mundo__vacio">' + vacio + '</p>'; return; }
    var max = top[0].q;
    el.innerHTML = '<ol>' + top.map(function (x) {
      var on = x.on ? ' is-on' : '';
      return '<li class="' + on + '"><span class="cod">' + x.cod + '</span><span class="riel"><i style="width:' +
        Math.max(6, Math.round(x.q / max * 100)) + '%"></i></span><span class="q">' + x.q + '</span></li>';
    }).join('') + '</ol>';
  }
  function pintarRankings() {
    var est = Object.keys(Q).map(function (k) { return { cod: k, q: Q[k], on: Q[k] >= U_EST }; })
      .sort(function (a, b) { return b.q - a.q; });
    ranking(est, $('[data-m-rank-est]'), T('vacioEst'), 6);
    ranking(CIUDADES.map(function (c) { return { cod: c.n, q: c.q, on: c.q >= U_CIU }; }),
            $('[data-m-rank-ciu]'), T('vacioCiu'), 5);
  }

  /* ---------- ficha ---------- */
  var ficha = $('[data-m-ficha]'), fN = $('[data-m-ficha-n]'), fQ = $('[data-m-ficha-q]'),
      fU = $('[data-m-ficha-u]'), fD = $('[data-m-ficha-d]');
  function verFicha(nombre, q, umbral, tipo) {
    if (!ficha) return;
    ficha.hidden = false;
    fN.textContent = nombre;
    fQ.textContent = q || 0;
    fU.textContent = q === 1 ? T('pre1') : T('pre');
    fD.textContent = !q ? T('fichaNada') : (q >= umbral ? TX[idioma()].fichaOk(tipo) : TX[idioma()].fichaFalta(umbral - q, tipo));
    ficha.classList.toggle('is-on', q >= umbral);
  }
  function ocultarFicha() { if (ficha) ficha.hidden = true; }

  /* ======================================================================
     ARRANQUE PEREZOSO
     ====================================================================== */
  var cv = $('[data-m-lienzo]');
  var escena = $('[data-m-escena]');
  var capaPines = $('[data-m-pines]');
  var barco = $('[data-m-barco]');
  var motor = null, visible = false, sucio = true, vista = 'ruta', explorando = false;

  function cargarGeo(listo) {
    if (W.HUMO_GEO) return listo();
    var s = document.createElement('script');
    s.src = CFG.geo; s.async = true;
    s.onload = function () { if (W.HUMO_GEO) listo(); };
    document.head.appendChild(s);
  }

  var io = 'IntersectionObserver' in W ? new IntersectionObserver(function (en) {
    en.forEach(function (x) {
      visible = x.isIntersecting;
      if (visible && !motor) cargarGeo(iniciar);
      if (visible) { sucio = true; pedir(); }
    });
  }, { rootMargin: '400px 0px' }) : null;
  if (io) io.observe(raiz); else cargarGeo(iniciar);

  /* ======================================================================
     ESCENA
     ====================================================================== */
  var cam = { lon: -78, lat: 18, z: 1 }, meta = null;
  var arrastre = null, ultimoToque = 0, rumbo = 0;
  var demoIni = 0, demoDur = 9000;
  var nodos = [];
  var selEstado = null;

  function iniciar() {
    if (motor || !cv) return;
    motor = Motor(cv, W.HUMO_GEO);
    motor.fijarRuta(RUTA);
    medir();
    montarPines();
    pintarRankings();
    textosFijos();
    eventos();
    W.addEventListener('resize', function () { clearTimeout(medir.t); medir.t = setTimeout(medir, 120); }, { passive: true });
    pedir();
  }

  function medir() {
    if (!motor) return;
    var w = cv.clientWidth, h = cv.clientHeight;
    var dpr = Math.min(W.devicePixelRatio || 1, movil() ? 1.5 : 2);
    motor.medir(w, h, dpr);
    if (vista === 'estados') construirTablero();
    sucio = true; pedir();
  }

  function geometria() {
    var w = cv.clientWidth, h = cv.clientHeight;
    var R = movil() ? Math.min(w * .46, h * .44) : Math.min(w, h) * .40;
    return { cx: w / 2, cy: movil() ? h * .52 : h * .60, R: R };
  }

  function construirTablero() {
    var w = cv.clientWidth, h = cv.clientHeight, m = movil();
    motor.construir({
      q: Q, umbral: U_EST,
      margen: m ? { arr: 16, aba: 16, izq: 10, der: 54 }
                : { arr: h * .16, aba: h * .14, izq: w * .2, der: w * .2 },
      txt: { faltan: TX[idioma()].faltan },
      fuente: '"Anton", Impact, sans-serif', texto: '"Archivo", system-ui, sans-serif'
    });
    var est = motor.estados(), abiertos = 0, cerca = null;
    est.forEach(function (e) {
      if (e.q >= U_EST) abiertos++;
      else if (e.q > 0 && (!cerca || e.q > cerca.q)) cerca = e;
    });
    var r = $('[data-m-resumen]');
    if (r) r.textContent = TX[idioma()].resumen(abiertos, est.length, cerca ? { n: cerca.n, f: U_EST - cerca.q } : null);
  }

  /* ---------- pines de ciudad y barco ---------- */
  var ICONO = '<svg viewBox="0 0 12 14" aria-hidden="true"><path d="M2 2h8l1 2v7l-1 2H2l-1-2V4z" fill="currentColor"/><path d="M1 6h10M1 9h10" stroke="#0B0C10" stroke-width=".9"/></svg>';
  function montarPines() {
    if (!capaPines) return;
    capaPines.innerHTML = '';
    nodos = [];
    SEDES.forEach(function (s) {
      var el = document.createElement('span');
      el.className = 'hb-mundo__sede' + (s.casa ? ' is-casa' : '');
      el.innerHTML = '<i>' + LOGO + '</i><span>' + s.n + '</span>';
      capaPines.appendChild(el);
      nodos.push({ el: el, c: s, x: -1, y: -1, v: false, fijo: true });
    });
    var can = document.createElement('button');
    can.type = 'button';
    can.className = 'hb-mundo__pin hb-mundo__pin--pais' + (CANADA >= U_EST ? ' is-on' : '');
    can.innerHTML = ICONO + '<b>' + CANADA + '</b><span data-m-canada>' + T('canada') + '</span>';
    var cdat = { n: 'Canada', lon: -101, lat: 57, q: CANADA };
    can.addEventListener('click', function (ev) {
      ev.stopPropagation();
      meta = { lon: cdat.lon, lat: 50, z: 1.6 }; explorando = true;
      var bx = $('[data-m-explorar]'); if (bx) bx.textContent = T('volver');
      nodos.forEach(function (n) { n.el.classList.toggle('is-sel', n.el === can); });
      verFicha(T('canada'), CANADA, U_EST, 'p');
      if (fD && CANADA < U_EST) fD.textContent = (CANADA ? TX[idioma()].fichaFalta(U_EST - CANADA, 'p') + ' ' : '') + T('fichaPais');
      sucio = true; pedir();
    });
    capaPines.appendChild(can);
    nodos.push({ el: can, c: cdat, x: -1, y: -1, v: false, fijo: true });

    CIUDADES.forEach(function (c) {
      var el = document.createElement('button');
      el.type = 'button';
      el.className = 'hb-mundo__pin' + (c.q >= U_CIU ? ' is-on' : '');
      el.innerHTML = ICONO + '<b>' + (c.q || 0) + '</b><span>' + c.n + '</span>';
      el.addEventListener('click', function (ev) { ev.stopPropagation(); elegirCiudad(c, el); });
      capaPines.appendChild(el);
      nodos.push({ el: el, c: c, x: -1, y: -1, v: false });
    });
  }
  function elegirCiudad(c, el) {
    meta = { lon: c.lon, lat: clamp(c.lat - 4, -60, 60), z: 2.6 };
    explorando = true;
    var bx = $('[data-m-explorar]'); if (bx) bx.textContent = T('volver');
    nodos.forEach(function (n) { n.el.classList.toggle('is-sel', n.el === el); });
    verFicha(c.n, c.q, U_CIU, 'c');
    sucio = true; pedir();
  }

  var PT = [0, 0, 0];
  function ubicar(g) {
    var mostrar = vista === 'ruta';
    for (var k = 0; k < nodos.length; k++) {
      var n = nodos[k];
      motor.proy(n.c.lon, n.c.lat, PT);
      var v = mostrar && PT[2] > (n.fijo ? .2 : .12) && (n.fijo || cam.z > .95);
      if (v !== n.v) { n.el.style.display = v ? '' : 'none'; n.v = v; }
      if (!v) continue;
      var x = Math.round(PT[0]), y = Math.round(PT[1]);
      if (x !== n.x || y !== n.y) { n.el.style.transform = 'translate(' + x + 'px,' + y + 'px)'; n.x = x; n.y = y; }
    }
    if (barco) {
      var p = motor.puntoRuta(progRuta());
      motor.proy(p[0], p[1], PT);
      var vb = mostrar && PT[2] > 0;
      barco.style.display = vb ? '' : 'none';
      if (vb) barco.style.transform = 'translate(' + Math.round(PT[0]) + 'px,' + Math.round(PT[1]) + 'px)';
    }
  }

  /* el contenedor avanza solo de Colombia a Miami y vuelve a empezar */
  var CICLO = 26000, PAUSA = 1800, T0 = Date.now();
  function progRuta() {
    if (demoIni) {
      var t = (Date.now() - demoIni) / demoDur;
      if (t >= 1) { demoIni = 0; T0 = Date.now(); return 0; }
      return t;
    }
    if (reducido) return progFecha();
    var e = (Date.now() - T0) % (CICLO + PAUSA);
    return Math.min(1, e / CICLO);
  }

  /* ---------- parada que se narra ---------- */
  var pT = $('[data-m-parada-t]'), pD = $('[data-m-parada-d]'), paradaK = -1;
  function narrar(p) {
    var k = p < .34 ? 0 : (p < .78 ? 1 : 2);
    if (k === paradaK || !pT) return;
    paradaK = k;
    pT.textContent = T('paradas')[k][0];
    if (pD) pD.textContent = T('paradas')[k][1];
  }

  /* ======================================================================
     BUCLE: solo corre si la sección está a la vista y hay algo que mover
     ====================================================================== */
  var pedido = false, ultimoCuadro = 0;
  function pedir() { if (!pedido && motor && visible) { pedido = true; requestAnimationFrame(cuadro); } }

  function cuadro(ts) {
    pedido = false;
    if (!visible || !motor) return;

    /* en celular, máximo 30 cuadros por segundo mientras gira solo */
    var anima = vista === 'ruta' && (!!meta || !!demoIni || (!arrastre && !reducido));
    if (anima && !meta && movil() && ts - ultimoCuadro < 32) { pedir(); return; }
    ultimoCuadro = ts;

    if (vista === 'ruta') {
      if (meta) {
        var dl = ((meta.lon - cam.lon + 540) % 360) - 180;
        cam.lon += dl * .1; cam.lat = lerp(cam.lat, meta.lat, .1); cam.z = lerp(cam.z, meta.z, .1);
        if (Math.abs(dl) < .2 && Math.abs(cam.z - meta.z) < .01 && Math.abs(cam.lat - meta.lat) < .1) meta = null;
      } else if (!arrastre && !explorando && !reducido && Date.now() - ultimoToque > 2500) {
        /* vaivén lento sobre las Américas: la ruta nunca se esconde */
        rumbo += .0045;
        cam.lon = lerp(cam.lon, -80 + Math.sin(rumbo) * 16, .04);
        cam.lat = lerp(cam.lat, 18, .03);
        cam.z = lerp(cam.z, 1, .03);
      }
      var g = geometria(), pr = progRuta();
      motor.globo({ lon: cam.lon, lat: cam.lat, z: cam.z, cx: g.cx, cy: g.cy, R: g.R, prog: pr,
                    q: Q, umbral: U_EST, movil: movil() });
      ubicar(g);
      narrar(pr);
      if (anima) pedir();
    } else if (sucio) {
      motor.pintarTablero(selEstado);
      ubicar();
    }
    sucio = false;
  }

  /* ======================================================================
     EVENTOS
     ====================================================================== */
  function eventos() {
    function local(e) { var r = cv.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; }
    function sobreGlobo(x, y) {
      var g = geometria(), R = g.R * cam.z;
      return (x - g.cx) * (x - g.cx) + (y - g.cy) * (y - g.cy) <= R * R * 1.06;
    }

    cv.addEventListener('pointerdown', function (e) {
      if (vista !== 'ruta') return;
      var p = local(e);
      if (!sobreGlobo(p[0], p[1])) return;
      arrastre = { x: e.clientX, y: e.clientY, mov: 0 };
      meta = null; ultimoToque = Date.now();
      try { cv.setPointerCapture(e.pointerId); } catch (er) {}
    });
    cv.addEventListener('pointermove', function (e) {
      var p = local(e);
      if (vista === 'estados') {
        var est = motor && motor.estadoEn(p[0], p[1]);
        if (est !== selEstado) {
          selEstado = est;
          if (est) verFicha(est.n, est.q, U_EST, 'e'); else ocultarFicha();
          sucio = true; pedir();
        }
        cv.style.cursor = est ? 'pointer' : '';
        return;
      }
      cv.style.cursor = sobreGlobo(p[0], p[1]) ? (arrastre ? 'grabbing' : 'grab') : '';
      if (!arrastre) return;
      var dx = e.clientX - arrastre.x, dy = e.clientY - arrastre.y;
      arrastre.mov += Math.abs(dx) + Math.abs(dy);
      cam.lon -= dx * (.28 / cam.z);
      cam.lat = clamp(cam.lat + dy * (.22 / cam.z), -70, 75);
      arrastre.x = e.clientX; arrastre.y = e.clientY;
      ultimoToque = Date.now();
      pedir();
    });
    function soltar() { arrastre = null; ultimoToque = Date.now(); pedir(); }
    cv.addEventListener('pointerup', soltar);
    cv.addEventListener('pointercancel', soltar);
    cv.addEventListener('pointerleave', function () {
      if (vista === 'estados' && selEstado && !movil()) { selEstado = null; ocultarFicha(); sucio = true; pedir(); }
    });

    /* la rueda solo hace zoom encima del planeta; fuera, la página baja */
    cv.addEventListener('wheel', function (e) {
      if (vista !== 'ruta') return;
      var p = local(e);
      if (!sobreGlobo(p[0], p[1])) return;
      e.preventDefault();
      meta = null; ultimoToque = Date.now();
      cam.z = clamp(cam.z * (e.deltaY < 0 ? 1.1 : .91), .8, 4.5);
      explorando = cam.z > 1.3;
      pedir();
    }, { passive: false });

    /* dos dedos para acercar */
    var dedos = {}, base = 0, baseZ = 1;
    function distancia() {
      var k = Object.keys(dedos); if (k.length < 2) return 0;
      var a = dedos[k[0]], b = dedos[k[1]];
      return Math.sqrt((a.x - b.x) * (a.x - b.x) + (a.y - b.y) * (a.y - b.y));
    }
    cv.addEventListener('touchstart', function (e) {
      for (var i = 0; i < e.touches.length; i++) dedos[e.touches[i].identifier] = { x: e.touches[i].clientX, y: e.touches[i].clientY };
      if (e.touches.length === 2) { base = distancia(); baseZ = cam.z; arrastre = null; }
    }, { passive: true });
    cv.addEventListener('touchmove', function (e) {
      for (var i = 0; i < e.touches.length; i++) dedos[e.touches[i].identifier] = { x: e.touches[i].clientX, y: e.touches[i].clientY };
      if (e.touches.length === 2 && base > 0 && vista === 'ruta') {
        e.preventDefault();
        cam.z = clamp(baseZ * distancia() / base, .8, 4.5);
        explorando = cam.z > 1.3; ultimoToque = Date.now(); pedir();
      }
    }, { passive: false });
    cv.addEventListener('touchend', function (e) {
      for (var i = 0; i < e.changedTouches.length; i++) delete dedos[e.changedTouches[i].identifier];
      if (Object.keys(dedos).length < 2) base = 0;
    }, { passive: true });

    /* vistas */
    Array.prototype.forEach.call(raiz.querySelectorAll('[data-m-vista]'), function (b) {
      b.addEventListener('click', function () {
        vista = b.getAttribute('data-m-vista');
        raiz.setAttribute('data-vista', vista);
        Array.prototype.forEach.call(raiz.querySelectorAll('[data-m-vista]'), function (o) {
          o.classList.toggle('is-on', o === b);
          o.setAttribute('aria-pressed', String(o === b));
        });
        ocultarFicha(); selEstado = null;
        nodos.forEach(function (n) { n.el.classList.remove('is-sel'); });
        if (vista === 'estados') construirTablero();
        sucio = true; pedir();
      });
    });

    var bx = $('[data-m-explorar]');
    if (bx) bx.addEventListener('click', function () {
      explorando = !explorando;
      meta = explorando ? { lon: -92, lat: 31, z: 1.9 } : { lon: -80, lat: 18, z: 1 };
      bx.textContent = explorando ? T('volver') : T('explorar');
      if (!explorando) { ocultarFicha(); nodos.forEach(function (n) { n.el.classList.remove('is-sel'); }); }
      pedir();
    });

    var bd = $('[data-m-demo]');
    if (bd) bd.addEventListener('click', function () {
      demoIni = Date.now(); paradaK = -1;
      meta = { lon: -80, lat: 18, z: 1 }; explorando = false;
      pedir();
    });

    var ir = $('[data-m-ir]');
    if (ir) ir.addEventListener('click', function () {
      var pre = document.querySelector('[data-preorder-root]');
      if (pre) pre.scrollIntoView({ behavior: reducido ? 'auto' : 'smooth', block: 'start' });
    });

    document.addEventListener('humo:idioma', function () {
      paradaK = -1;
      var cn = raiz.querySelector('[data-m-canada]'); if (cn) cn.textContent = T('canada');
      textosFijos();
      pintarRankings();
      if (vista === 'estados') construirTablero();
      ocultarFicha();
      sucio = true; pedir();
    });
  }
  textosFijos();
  pintarRankings();
})(typeof window !== 'undefined' ? window : globalThis);
